/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Launch_New_LaunchesInputs */

const en_directory_launch_new_launches = /** @type {(inputs: Directory_Launch_New_LaunchesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New launches`)
};

const zh_directory_launch_new_launches = /** @type {(inputs: Directory_Launch_New_LaunchesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新发布`)
};

/**
* | output |
* | --- |
* | "New launches" |
*
* @param {Directory_Launch_New_LaunchesInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_launch_new_launches = /** @type {((inputs?: Directory_Launch_New_LaunchesInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Launch_New_LaunchesInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_launch_new_launches(inputs)
	return zh_directory_launch_new_launches(inputs)
});
export { directory_launch_new_launches as "directory.launch.new_launches" }